import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IndustryTypeProps } from "../types/attribute/industry_type";
import { api } from "../services/api.service";

export const fetchIndustryTypes = createAsyncThunk<IndustryTypeProps[]>(
  "fetch/industry-types",
  async () => {
    const data = await api.attribute.industryType.getAll();
    return data.data as IndustryTypeProps[];
  }
);

interface IndustryTypeState {
  industryTypes: IndustryTypeProps[];
  industry_type: null | IndustryTypeProps;
  loading: boolean;
  error: null | string;
}

const initialState: IndustryTypeState = {
  industryTypes: [],
  industry_type: null,
  loading: false,
  error: null,
};

export const industryTypeSlice = createSlice({
  name: "industry-type",
  initialState,
  reducers: {
    addIndustryType: (state, action: PayloadAction<IndustryTypeProps>) => {
      state.industryTypes.push(action.payload);
    },
    removeIndustryType: (state, action: PayloadAction<{ id: number }>) => {
      state.industryTypes = state.industryTypes.filter(
        (industry_type) => industry_type.id !== action.payload.id
      );
    },
    updateIndustryType: (state, action: PayloadAction<IndustryTypeProps>) => {
      state.industryTypes = state.industryTypes.map((industry_type) =>
        industry_type.id === action.payload.id ? action.payload : industry_type
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchIndustryTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIndustryTypes.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.industryTypes = action.payload;
      })
      .addCase(fetchIndustryTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export const { addIndustryType, removeIndustryType, updateIndustryType } =
  industryTypeSlice.actions;

export default industryTypeSlice.reducer;
